// extracted by mini-css-extract-plugin
var _1 = "_text-module__bold";
var _2 = "_text-module__container";
var _3 = "_text-module__error";
var _4 = "_text-module__font-size-l";
var _5 = "_text-module__font-size-m";
var _6 = "_text-module__font-size-s";
var _7 = "_text-module__font-size-xl";
var _8 = "_text-module__underline";
export { _1 as "bold", _2 as "container", _3 as "error", _4 as "font-size-l", _5 as "font-size-m", _6 as "font-size-s", _7 as "font-size-xl", _8 as "underline" }
